import React from "react";
import MDLoadingButton from "../MDLoadingButton";
import MDBox from "materialDashboard/components/MDBox";
import {useTranslation} from "react-i18next";


const FiltersBox = ({onApplyFilters, children, isLoading}) => {
    const {t} = useTranslation(["models1"]);

    return <MDBox padding={2} bgColor="#f8f9fa" borderRadius={"8px"}>
        {children}
        <MDBox textAlign="right" mt={2}>
            <MDLoadingButton variant="gradient"
                             color="info"
                             loading={isLoading}
                             onClick={onApplyFilters}>
                {t("table.filter")}
            </MDLoadingButton>
        </MDBox>
    </MDBox>
}

export default FiltersBox;